import type { IQuaternion, ITransformRT3, IVector3 } from '@seddi/math-v2';

import type { Viewer } from '../components/AppViewer/AppViewer';
import type { AppViewerTool } from '../components/AppViewer/appViewerTool';
import type { TCamera } from '../types/protocolTypes';
import { computeCameraLookAtFromTransform } from '../viewer/cameraLookAtFromTransform';

const degToRad = (deg: number): number => {
  return deg * (Math.PI / 180.0);
};

const radToDeg = (rad: number): number => {
  return rad * (180.0 / Math.PI);
};

const setCameraFromTransform = (viewer: Viewer, transform: ITransformRT3) => {
  const lookAt = computeCameraLookAtFromTransform(transform);
  const tool = viewer.tool as unknown as AppViewerTool;
  tool.lookAt(lookAt.origin, lookAt.target);
};

export const setCamera = (() => {
  const farDef = 10.0;
  const fovDef = degToRad(20.0);
  const nearDef = 0.1;
  const translationDef: IVector3 = { x: 0.0, y: 1.2, z: 3.0 };
  const rotationDef: IQuaternion = { x: 0.0, y: 0.0, z: 0.0, w: 1.0 };

  return (viewer: Viewer, desc: TCamera) => {
    const far = desc.far ?? farDef;
    const fov = desc.fov ?? fovDef;
    const near = desc.near ?? nearDef;
    const rotation = desc.transform?.rotation ?? rotationDef;
    const translation = desc.transform?.translation ?? translationDef;
    // update transform
    const transform: ITransformRT3 = { rotation, translation };
    setCameraFromTransform(viewer, transform);
    // update projection matrix
    const camera = viewer.camera;
    camera.far = far;
    camera.fov = radToDeg(fov);
    camera.near = near;
    camera.updateProjectionMatrix();
  };
})();
